export default __webpack_public_path__ + "static/media/rangeHappy.f84a0298.svg";